export default {
    SET_SELECT_SYNDICATOR({commit},Syndicator){
        commit('SET_SELECT_SYNDICATOR',Syndicator)
    },
    SET_RESULT({commit},result){
        commit('SET_RESULT',result)
    },
    SET_EDIT_SYNDICATOR({commit},editSyndicator){
        commit('SET_EDIT_SYNDICATOR',editSyndicator)
    },
}
